export default "__VITE_ASSET__ZSLMxitW__"